<div class="analisis-wrapper">

  <div class="toolbar">
    <!-- Fila 1: selectores del padre (su ancho cambia con los datos) -->
    <div class="toolbar-row toolbar-row-selectores">
      <ng-content select="[slot=toolbar-start]"></ng-content>
    </div>
    <!-- Fila 2: periodo y zoom, en posición fija -->
    <div class="toolbar-row">
      <ng-content select="[slot=toolbar-row2-start]"></ng-content>
      <span class="group-label" title="Duración de cada vela">Periodo</span>
      <div class="periodo-group">
        <button *ngFor="let p of periodos"
          [class.active]="activePeriodo === p.id"
          [disabled]="loading"
          [title]="'Velas de ' + p.label"
          (click)="setPeriodo(p.id)">{{ p.label }}</button>
      </div>
      <label class="premarket-check" *ngIf="!metaapi" [class.disabled]="!isIntraday"
        [title]="isIntraday
          ? 'Muestra también las velas previas a la apertura (solo visual, no se usa en cálculos)'
          : 'El premarket solo está disponible en periodos intradía (1m a 4H)'">
        <input type="checkbox" [checked]="premarket" [disabled]="loading || !isIntraday" (change)="togglePremarket()">
        Premarket
      </label>
      <div class="separator"></div>
      <span class="group-label" title="Tramo de tiempo visible en la gráfica">Zoom</span>
      <div class="range-group">
        <button title="Ver el último mes" [disabled]="rangeLoading" (click)="setRange('1M')">1M</button>
        <button title="Ver los últimos 3 meses" [disabled]="rangeLoading" (click)="setRange('3M')">3M</button>
        <button title="Ver los últimos 6 meses" [disabled]="rangeLoading" (click)="setRange('6M')">6M</button>
        <button title="Ver el último año" [disabled]="rangeLoading" (click)="setRange('1Y')">1A</button>
        <button [title]="rangeLoading ? 'Cargando histórico…' : 'Ver toda la serie'" [disabled]="rangeLoading" (click)="setRange('all')">Todo</button>
      </div>
      <ng-content select="[slot=toolbar-after-zoom]"></ng-content>
      <span class="download-badge" *ngIf="descargando && !noData" [title]="progresoTexto">
        <span class="download-spin">⟳</span>
        <span class="download-text">{{ progresoTexto }}</span>
      </span>
      <span class="live-badge" *ngIf="enVivo" title="Actualizando las últimas velas desde MetaAPI">
        <span class="live-dot"></span>En vivo
      </span>
    </div>
  </div>

  <!-- Toolbar de dibujo compartida (estilo TradingView) + chart -->
  <div class="chart-body">
    <app-drawing-toolbar class="drawing-toolbar-host" [controller]="drawingCtl"></app-drawing-toolbar>
    <div class="chart-stack">
      <div id="analisisChartContainer"></div>
      <div class="chart-msg" *ngIf="loading && !descargando">Cargando…</div>
      <div class="chart-msg chart-msg-accion" *ngIf="!loading && noData">
        <ng-container *ngIf="descargando; else sinDescarga">
          <span>{{ progresoTexto }}</span>
          <mat-progress-bar [mode]="progresoValor !== null ? 'determinate' : 'indeterminate'"
            [value]="progresoValor ?? 0"></mat-progress-bar>
        </ng-container>
        <ng-template #sinDescarga>
          <ng-container *ngIf="faltaMetaapi">
            <span>Conecta MetaAPI para descargar {{ compania }}</span>
            <button mat-stroked-button color="primary" (click)="conectarMetaapi()">Conectar MetaAPI</button>
          </ng-container>
          <span *ngIf="!faltaMetaapi && sinDatosFuente">No hay datos disponibles para {{ activePeriodoLabel }} en {{ compania }}</span>
          <ng-container *ngIf="!faltaMetaapi && !sinDatosFuente">
            <span>Sin datos para {{ activePeriodoLabel }} en {{ compania }}</span>
            <small *ngIf="!idnectum">Selecciona el activo desde su mercado para descargarlo</small>
          </ng-container>
        </ng-template>
      </div>
      <app-drawing-floating-toolbar [controller]="drawingCtl"></app-drawing-floating-toolbar>
      <app-drawing-object-tree [controller]="drawingCtl"></app-drawing-object-tree>
    </div>
  </div>

</div>
